import { formatHubBranchLabel } from './destinationType.js';
import { isLrShipmentFormat } from './shipmentIdFormat.js';

/** Same label as Add Shipment: `05 – Place` when Number sequence is on. */
export function formatLocationDropdownLabel(loc, useNumberCode = false) {
  const lr = String(loc?.lr_branch_code || '').trim();
  const place = String(loc?.location || formatHubBranchLabel(loc) || '').trim();
  if (useNumberCode && /^\d{2}$/.test(lr) && place) return `${lr} – ${place}`;
  const name = formatHubBranchLabel(loc);
  const code = (loc?.location_code || loc?.hub_code || '').trim();
  return code ? `${name} (${code})` : name;
}

export function locationMatchesQuery(loc, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return true;
  const name = String(loc?.location || '').toLowerCase();
  const code = String(loc?.location_code || loc?.hub_code || '').toLowerCase();
  const lr = String(loc?.lr_branch_code || '').toLowerCase();
  const label = formatHubBranchLabel(loc).toLowerCase();
  return name.includes(q) || code.includes(q) || lr.includes(q) || label.includes(q);
}

export function locationMatchRank(loc, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return 2;
  const name = String(loc?.location || '').toLowerCase();
  const code = String(loc?.location_code || loc?.hub_code || '').toLowerCase();
  const lr = String(loc?.lr_branch_code || '').toLowerCase();
  const label = formatHubBranchLabel(loc).toLowerCase();
  if (code === q || name === q || label === q || lr === q) return 0;
  if (code.startsWith(q) || name.startsWith(q) || label.startsWith(q) || lr.startsWith(q)) return 1;
  return 2;
}

export function filterLocationsByQuery(locations, query) {
  const list = Array.isArray(locations) ? locations : [];
  const q = String(query || '').trim();
  if (!q) return list;
  return list
    .filter((loc) => locationMatchesQuery(loc, q))
    .sort((a, b) => locationMatchRank(a, q) - locationMatchRank(b, q));
}

export function useLrLocationLabels(shipmentIdFormat) {
  return isLrShipmentFormat(shipmentIdFormat);
}
